exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.main[data-v-5e774644] {\n    text-align: center;\n    padding: 49px;\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box;\n    border: 1px solid #E8E8E8;\n    border-radius: 5px;\n}\n.mb20[data-v-5e774644] {\n  margin-bottom: 21px;\n}\n.mb40[data-v-5e774644] {\n  margin-bottom: 40px;\n}\n@media (max-width: 960px) {\n.f16[data-v-5e774644] {\n  white-space: inherit;\n  text-align: left;\n}\n.main[data-v-5e774644] {\n  padding: 25px\n}\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5e774644","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/account-settings/screens/RightComponent.vue
// module id = 1151
// module chunks = 0